import GET_COMPANIES from '@/graphql/Companies.gql'
import { ref, computed } from '@vue/composition-api'
import { useQuery, useResult } from '@vue/apollo-composable'

export function useCompanies() {
  const search = ref('')
  const selectedFilter = ref('')
  const selectedSubFilters = ref(['ENABLED'])
  const { result, loading, error } = useQuery(
    GET_COMPANIES,
    () => ({
      search: search.value,
      ...(selectedFilter.value &&
        selectedFilter.value !== '' && {
          companyType: selectedFilter.value,
        }),
      isChurn: selectedSubFilters.value.includes('CHURN') ? true : undefined,
      enabled:
        selectedSubFilters.value.includes('ENABLED') &&
        selectedSubFilters.value.includes('DISABLED')
          ? undefined
          : selectedSubFilters.value.includes('ENABLED')
          ? true
          : selectedSubFilters.value.includes('DISABLED')
          ? false
          : undefined,
    }),
    { fetchPolicy: 'cache-first' }
  )
  const companies = useResult(result, [], data =>
    data.companies.map(c => ({
      ...c,
      displayname: c.displayname ? c.displayname : c.name,
    }))
  )

  const filters = ref([
    { label: 'Alla', value: '' },
    { label: 'Salong', value: 'SALOON' },
    { label: 'Hyrstol', value: 'RENTAL_COMPANY' },
    { label: 'Skal', value: 'SHELL' },
    { label: 'Leverantör', value: 'SUPPLIER' },
  ])

  const subfilters = ref([
    { label: 'Aktiva', value: 'ENABLED' },
    { label: 'Inaktiva', value: 'DISABLED' },
    { label: 'Ej igång', value: 'PENDING_ACTIVATION' },
    { label: 'Pågång', value: 'ONGOING_ACTIVATION' },
    { label: 'Churn', value: 'CHURN' },
  ])

  const noneRentalChairs = computed(() => {
    return companies.value.filter(c => !c.parentCompanyId)
  })
  const filteredCompanies = computed(() => {
    return companies.value.filter(c => {
      let isFiltered = true
      if (selectedSubFilters.value.includes('PENDING_ACTIVATION')) {
        isFiltered =
          selectedSubFilters.value.includes('PENDING_ACTIVATION') &&
          !c.activationDate &&
          !c.disabledDate &&
          !c.enabled
      } else if (selectedSubFilters.value.includes('ONGOING_ACTIVATION')) {
        isFiltered =
          selectedSubFilters.value.includes('ONGOING_ACTIVATION') &&
          c.activationDate &&
          new Date(c.activationDate) > new Date()
            ? true
            : false
      }
      return isFiltered
    })
  })

  return {
    companies: filteredCompanies,
    loading,
    error,
    search,
    noneRentalChairs,
    selectedFilter,
    selectedSubFilters,
    subfilters,
    filters,
  }
}
